import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  makeStyles,
  AppBar,
  Tabs,
  Tab,
  Typography,
  Box,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import { getAllData, TestData } from "../../Redux/action/action";
import Frame from "../../Assets/Images/Icon/Frame.svg";
import {
  questionDataMaziMaroof,
  questionDataMaziMujhool,
  questionDataMuzariyaMaroof,
  questionDataMuzariyaMujhool,
  questionDataAmur,
  questionDataMauzariyaMunsoob,
} from "../MashaqContent/AllWordsArray";
import { useHistory } from "react-router";
import Layout from "../../Components/Layout/Layout";
import Navbar from "../../Components/Navbar/Navbar";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: "0.1rem",
    "& .MuiTab-root": {
      minWidth: "127px",
    },
    "& .MuiTabs-flexContainer": {
      justifyContent: "center",
    },
    "& .MuiTab-root": {
      backgroundColor: "#F8DC0F",
      fontSize: "1.2rem",
      color: "#104A6C",
      padding: "12px 50px",
      marginBottom: "1rem",
      fontWeight: "700",
    },
    [theme.breakpoints.down("md")]: {
      "& .MuiBox-root": {
        padding: "0px",
      },
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
  },
}));
// const Question = () => {

//   return (

//   );
// };
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const QuestionCardFail = () => {
  const dispatch = useDispatch();
  let { name, testname } = useParams();

  const state = useSelector((state) => state);

  let startIs;
  if (name == "Maazi-Maroof") {
    startIs = "ماضی معروف";
  } else if (name == "Muzariya-Maroof") {
    startIs = "ﻣﹹﻀﺎﺭﻉ معروف";
  } else if (name == "Mazi-Mujhool") {
    startIs = "ماضی مجہول";
  } else if (name == "Muzariya-Mujhool") {
    startIs = "ﻣﹹﻀﺎﺭﻉ مجہول";
  } else if (name == "Amur") {
    startIs = "امر";
  } else if (name == "Muzariya-Munsoob") {
    startIs = "ﻣﹹﻀﺎﺭﻉ منصوب";
  }

  const classes = useStyles();
  const history = useHistory();
  const [value, setValue] = React.useState(0);
  const [arrayQuestions, setArrayQuestions] = React.useState([]);
  const [arraySolutions, setArraySolutions] = React.useState([]);
  const [arrayTests, setArrayTests] = React.useState([]);
  const [questionName, setQuestionName] = React.useState("");
  const [adhadh, setAdhadh] = React.useState("");
  const [jins, setJins] = React.useState("");
  const [segha, setSegha] = React.useState("");
  const testDate = new Date().toDateString();
  const handleChangeAdhadh = (event, item) => {
    setAdhadh(event.target.value);
    setQuestionName(item.text);
  };
  const handleChangeJins = (event) => {
    setJins(event.target.value);
  };
  const handleChangeSegha = (event) => {
    setSegha(event.target.value);
  };

  const handleChange = (event, newValue) => {
    if (adhadh == "" || jins == "" || segha == "") {
      alert("please select all options");
    } else {
      if (newValue < 2) {
        arraySolutions.push({
          text: questionName,
          zameerWahidJama: adhadh,
          zameerJins: jins,
          name: segha,
        });
        setValue(newValue + 1);
        setQuestionName("");
        setAdhadh("");
        setJins("");
        setSegha("");
      } else {
        // newAllTests.push({
        //   testName: `${testname} ${startIs}`,
        //   testDate: testDate,
        //   questionAsked: arrayQuestions,
        //   answerGiven: arraySolutions,
        // });
        arraySolutions.push({
          text: questionName,
          zameerWahidJama: adhadh,
          zameerJins: jins,
          name: segha,
        });
        // localStorage.setItem('All-Tests', JSON.stringify(newAllTests));
        const token = localStorage.getItem("token");
        dispatch(
          TestData(token, {
            testName: `${testname} ${startIs}`,
            testDate: testDate,
            questionAsked: arrayQuestions,
            answerGiven: arraySolutions,
          })
        );
        history.push("/report");
      }
    }
  };

  useEffect(() => {
    if (name == "Maazi-Maroof") {
      setArrayQuestions(
        questionDataMaziMaroof
          .sort(() => Math.random() - Math.random())
          .slice(0, 10)
      );
    } else if (name == "Muzariya-Maroof") {
      setArrayQuestions(
        questionDataMuzariyaMaroof
          .sort(() => Math.random() - Math.random())
          .slice(0, 10)
      );
    } else if (name == "Mazi-Mujhool") {
      setArrayQuestions(
        questionDataMaziMujhool
          .sort(() => Math.random() - Math.random())
          .slice(0, 10)
      );
    } else if (name == "Muzariya-Mujhool") {
      setArrayQuestions(
        questionDataMuzariyaMujhool
          .sort(() => Math.random() - Math.random())
          .slice(0, 10)
      );
    } else if (name == "Amur") {
      setArrayQuestions(
        questionDataAmur.sort(() => Math.random() - Math.random()).slice(0, 10)
      );
    } else if (name == "Muzariya-Munsoob") {
      setArrayQuestions(
        questionDataMauzariyaMunsoob
          .sort(() => Math.random() - Math.random())
          .slice(0, 10)
      );
    }

    setValue(0);
  }, []);

  // useEffect(() => {
  //   dispatch(getAllData());
  // }, [dispatch]);

  return (
    <div>
      <Navbar />
      <Layout mainClass="topicpage1" title="التصریف">
        <div className="questionCardHeadings">
          <div className={classes.root}>
            <h3
              style={{
                color: "#104A6C",
                fontSize: "1rem",
                marginTop: 50,
              }}
            >
              <img
                src={Frame}
                alt=""
                style={{ width: "50px", marginRight: "0.5rem" }}
              />
              التصریف
              <img
                src={Frame}
                alt=""
                style={{ width: "50px", marginLeft: "0.5rem" }}
              />
            </h3>
            <TabPanel
              className="question-card-main"
              value={value}
              index={value}
            >
              {arrayQuestions.map((item, index) => {
                if (index == value) {
                  return (
                    <>
                      <h3
                        style={{
                          color: "#F8DC0F",
                          borderRadius: 20,
                          marginTop: "2rem",
                        }}
                      >
                        سوال نمبر {index + 1}:
                        <span style={{ color: "black" }}>{item.text}</span>
                      </h3>

                      <div className="quiz-div">
                        <FormControl component="fieldset" className="quiz">
                          <RadioGroup
                            aria-label="adhadh"
                            name="adhadh"
                            value={adhadh}
                            onChange={(e) => handleChangeAdhadh(e, item)}
                          >
                            <Grid
                              style={{ backgroundColor: "whitesmoke" }}
                              container
                            >
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControlLabel
                                  value="جمع"
                                  control={<Radio />}
                                  label="جمع"
                                />
                              </Grid>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControlLabel
                                  value="واحد"
                                  control={<Radio color="default" />}
                                  label="واحد"
                                />
                              </Grid>
                            </Grid>
                            <Grid
                              style={{ backgroundColor: "whitesmoke" }}
                              container
                            >
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControlLabel
                                  value="تثنیہ/جمع"
                                  control={<Radio />}
                                  label="تثنیہ/جمع"
                                />
                              </Grid>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControlLabel
                                  value="تثنیہ"
                                  control={<Radio />}
                                  label="تثنیہ"
                                />
                              </Grid>
                            </Grid>
                          </RadioGroup>
                        </FormControl>
                        <br />

                        <FormControl component="fieldset" className="quiz">
                          <RadioGroup
                            aria-label="jins"
                            name="jins"
                            value={jins}
                            onChange={handleChangeJins}
                          >
                            <Grid
                              style={{ backgroundColor: "whitesmoke" }}
                              container
                            >
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControlLabel
                                  value=" مونث"
                                  control={<Radio />}
                                  label="مونث"
                                />
                              </Grid>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControlLabel
                                  value="مذکر"
                                  control={<Radio color="default" />}
                                  label="مذکر"
                                />
                              </Grid>
                            </Grid>
                            <Grid
                              style={{ backgroundColor: "whitesmoke" }}
                              container
                              justify="center"
                              alignItems="center"
                            >
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                {" "}
                                <FormControlLabel
                                  value="مذکر/مونث"
                                  control={<Radio />}
                                  label="مذکر/مونث"
                                />
                              </Grid>
                            </Grid>
                          </RadioGroup>
                        </FormControl>

                        <FormControl component="fieldset" className="quiz">
                          <RadioGroup
                            aria-label="Segha"
                            name="segha"
                            value={segha}
                            onChange={handleChangeSegha}
                          >
                            <Grid
                              style={{ backgroundColor: "whitesmoke" }}
                              container
                            >
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControlLabel
                                  value="حاضر"
                                  control={<Radio />}
                                  label="حاضر"
                                />
                              </Grid>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControlLabel
                                  value="غائب"
                                  control={<Radio />}
                                  label="غائب"
                                />
                              </Grid>
                            </Grid>
                            <Grid
                              style={{ backgroundColor: "whitesmoke" }}
                              container
                              justify="center"
                              alignItems="center"
                            >
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                {" "}
                                <FormControlLabel
                                  value="متکلم"
                                  control={<Radio />}
                                  label="متکلم"
                                />
                              </Grid>
                            </Grid>
                          </RadioGroup>
                        </FormControl>
                      </div>
                    </>
                  );
                }
              })}
            </TabPanel>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              {[...Array(10).keys()].map((countNumber) => (
                <Tab
                  label="تصدیق کریں"
                  {...a11yProps(countNumber)}
                  style={
                    value == countNumber
                      ? { display: "block" }
                      : { display: "none" }
                  }
                  disabled={value == 10 ? true : false}
                />
              ))}
            </Tabs>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default QuestionCardFail;
